const Loading = () => {
  return (
    <div className="group_empty type_fixed">
      <span className="icon icon_loading_type2">로딩중</span>
    </div>
  );
};

export default Loading;
